<template>
  <div class="btn" role="button" :selected="state" @click="change">
    <div>
      <img :src="state?require('../assets/images/device/power_e.png'):require('../assets/images/device/power.png')"
           style="width: 15px"/>
      <button v-text="text"></button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Button',
  props: ['state'],
  computed: {
    text () {
      return this.state ? '全部关闭' : '全部开启'
    }
  },
  methods: {
    change () {
      this.$emit('change')
    }
  }
}
</script>
<style scoped lang="less">
.btn[selected] {
  border: 1px solid #39d474;
  background-color: #39d474;
  button {
    color: white;
  }
}

.btn {
  display: inline-block;
  background-color: white;
  cursor: pointer;
  border: 1px solid rgba(218, 218, 218, 1);
  border-radius: 2px;
  width: 100px;
  height: 39px;
  position: relative;
  line-height: 37px;
  > div {
    display: inline-block;
    > button {
      cursor: pointer;
      background: transparent;
      border: 0;
      outline: 0 none !important;
      padding: 0;
      font-size: 13px;
      font-weight: 400;
      color: #1c324f;
    }
  }
  img {
    margin-right: 6px;
    vertical-align: middle;
    margin-left: 12px;
  }
}
</style>
